module.exports = __webpack_public_path__ + "static/johndigweed_0-f64555757dcafd1ea14959811aac4c4d.jpg";